/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_Step_ReconciliationInputs */

const en_input_process_step_reconciliation = /** @type {(inputs: Input_Process_Step_ReconciliationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconciliation`)
};

const nl_input_process_step_reconciliation = /** @type {(inputs: Input_Process_Step_ReconciliationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconciliatie`)
};

/**
* | output |
* | --- |
* | "Reconciliation" |
*
* @param {Input_Process_Step_ReconciliationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_step_reconciliation = /** @type {((inputs?: Input_Process_Step_ReconciliationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_Step_ReconciliationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_step_reconciliation(inputs)
	return en_input_process_step_reconciliation(inputs)
});